export default __webpack_public_path__ + "static/media/avatar.11e5768a.jpg";